// import React, { Component } from "react";
// import "./App.css";
// import Header from "../components/header/Header.js";
// import Footer from "../components/footer/Footer.js";
// import config from "../config/config.js";
// import { instanceOf } from "prop-types";
// import { withCookies, Cookies } from "react-cookie";
// import CryptoJS from "crypto-js";

import React from "react";
import { useContext } from "react";
import "./App.css";

import Header from "../components/header/Header.js";
import Footer from "../components/footer/Footer.js";
import { SomeContext, msalContext } from "./auth/auth";

// class App extends Component {
//   static propTypes = {
//     cookies: instanceOf(Cookies).isRequired,
//   };
//   // constructor(props) {
//   //   super(props);
//   //   this.state = {
//   //     isloaded: false,
//   //   };
//   // }
//   // componentWillMount() {
//   //   const { cookies } = this.props;
//   //   const secretKeyforEncryption = config.encryptionkey;
//   //   const aliasWWIDName = config.aliasWWIDName;
//   //   const ssoURL = config.ssoURL;
//   //   if (!this.props.allCookies.WWID) {
//   //     var location = decodeURIComponent(window.location.href);
//   //     cookies.set("ReturnUrl", location, { path: "/" }); // Use this if you want to redirect to current url after sso verify
//   //     window.location = ssoURL;
//   //   } else {
//   //     // You can use localStorage instead of sessionStorage if you dont want to remove the key on browser close.
//   //     var lsWWID = sessionStorage.getItem(aliasWWIDName); // configured lsMainKey in config and take this from config. This is the alias name of "WWID" in session storage.
//   //     var lsWWID_enc = "";
//   //     if (!lsWWID) {
//   //       lsWWID_enc = CryptoJS.AES.encrypt(
//   //         this.props.allCookies.WWID,
//   //         secretKeyforEncryption
//   //       );
//   //       sessionStorage.setItem(aliasWWIDName, lsWWID_enc); // this will set the encrypt value of WWID in aliasWWIDName.
//   //     } else {
//   //       var lsWWID_dec_bytes = CryptoJS.AES.decrypt(
//   //         lsWWID,
//   //         secretKeyforEncryption
//   //       );
//   //       var lsWWID_dec = JSON.parse(
//   //         lsWWID_dec_bytes.toString(CryptoJS.enc.Utf8)
//   //       ); //this will decrypt the encrypted value.
//   //       if (this.props.allCookies.WWID != lsWWID_dec) {
//   //         sessionStorage.setItem(aliasWWIDName, "");
//   //         cookies.set("WWID", "", { path: "/" });
//   //         window.location = ssoURL;
//   //       }
//   //     }
//   //     this.setState({
//   //       isloaded: true,
//   //     });
//   //   }
//   // }
//   // componentDidMount() {
//   //   if (this.state.isloaded) {
//   //     document.body.style.background = "#009";
//   //   }
//   // }
//   render() {
//     return (
//       <div className="App">
//         {/* {this.state.isloaded ?
//         <div>
//           <Header />
//             {this.props.children}
//           < Footer />
//         </div>:''
//         } */}
//         <Header />
//         {this.props.children}
//         <Footer />
//       </div>
//     );
//   }
// }
// export default withCookies(App);

// // export default (App);

function App(props) {
  const msal = useContext(msalContext);

  // const handleLogout = () => {
  //   console.log({ msal: msal.getAllAccounts() });
  //   msal.logout();
  //   // msal.loginRedirect();
  // };
  return (
    <div className="App">
      {/* {this.state.isloaded ?
        <div>
          <Header />
            {this.props.children}
          < Footer /> 
        </div>:''
        } */}
      <Header />
      {props.children}
      {/* <button onClick={handleLogout}>logout</button> */}
      <Footer />
    </div>
  );
}

export default App;
